<template>
  <v-container class="pa-0 weight-volume-container" :class="[$vuetify.breakpoint.xlOnly ? 'weight-volume-container-xl' : 'weight-volume-container-lg-down']">
      <v-row no-gutters>
        <v-col v-if="shipment.__typename === 'Shipment1PL' && shipment != null && shipment.vehicle.maxWeight && shipment.vehicle.maxVolume">
          <span class="text-no-wrap d-block text-right wrld_black--text">
            {{shipment.drops.weight | roundValueWeight(0)}} kg / <span :style="`color:${utilizationWeightColor};`">{{shipment.drops.weight | utilizationWeight(shipment.vehicle.maxWeight, 0)}}%</span>
          </span>
          <!-- <span v-else class="text-no-wrap d-block text-right wrld_black--text">
            {{shipment.drops.weight | roundValueWeight(0)}} kg
          </span> -->
          <span class="text-no-wrap d-block text-right wrld_black--text">
            {{shipment.drops.volume | roundValue(1)}} m&sup3; / <span :style="`color:${utilizationVolumeColor};`">{{shipment.drops.volume | utilizationVolume(shipment.vehicle.maxVolume, 0)}}%</span>
          </span>
          <!-- <span v-else class="text-no-wrap d-block text-right wrld_black--text">
            {{shipment.drops.volume | roundValue(1)}} m&sup3;
          </span> -->
        </v-col>
        <v-col v-else-if="shipment.__typename === 'Shipment1PL' && shipment.vehicle != null && !shipment.vehicle.maxWeight && !shipment.vehicle.maxVolume">
          <span v-if="shipment.drops.weight !== null" class="text-no-wrap d-block text-right wrld_black--text">{{shipment.drops.weight | roundValueWeight(0)}} kg</span>
          <span v-if="shipment.drops.volume !== null" class="text-no-wrap d-block text-right wrld_black--text">{{shipment.drops.volume | roundValue(1)}} m&sup3;</span>
        </v-col>
        <v-col v-if="shipment.__typename === 'Shipment2PL' && shipment.vehicleClass != null && shipment.vehicleClass.maxWeight && shipment.vehicleClass.maxVolume">
          <span class="text-no-wrap d-block text-right wrld_black--text">
            {{shipment.drops.weight | roundValueWeight(0)}} kg / <span :style="`color:${utilizationWeightColor};`">{{shipment.drops.weight | utilizationWeight(shipment.vehicle.maxWeight, 0)}}%</span>
          </span>
          <!-- <span v-else class="text-no-wrap d-block text-right wrld_black--text">
            {{shipment.drops.weight | roundValueWeight(0)}} kg
          </span> -->
          <span class="text-no-wrap d-block text-right wrld_black--text">
            {{shipment.drops.volume | roundValue(1)}} m&sup3; / <span :style="`color:${utilizationVolumeColor};`">{{shipment.drops.volume | utilizationVolume(shipment.vehicle.maxVolume, 0)}}%</span>
          </span>
          <!-- <span v-else class="text-no-wrap d-block text-right wrld_black--text">
            {{shipment.drops.volume | roundValue(1)}} m&sup3;
          </span> -->
        </v-col>
        <v-col v-else-if="shipment.__typename === 'Shipment2PL' && shipment.vehicleClass != null && !shipment.vehicleClass.maxWeight && !shipment.vehicleClass.maxVolume">
          <span v-if="shipment.drops.weight !== null" class="text-no-wrap d-block text-right wrld_black--text">{{shipment.drops.weight | roundValueWeight(0)}} kg</span>
          <span v-if="shipment.drops.volume !== null" class="text-no-wrap d-block text-right wrld_black--text">{{shipment.drops.volume | roundValue(1)}} m&sup3;</span>
        </v-col>
        <v-col v-else-if="shipment.__typename === 'ShipmentLTL' || shipment.__typename === 'ShipmentExpress' || shipment.__typename === 'NotTypedShipment'">
          <span v-if="shipment.drops.weight !== null" class="text-no-wrap d-block text-right wrld_black--text">{{shipment.drops.weight | roundValueWeight(0)}} kg</span>
          <span v-if="shipment.drops.volume !== null" class="text-no-wrap d-block text-right wrld_black--text">{{shipment.drops.volume | roundValue(1)}} m&sup3;</span>
        </v-col>
         <v-col v-else-if="shipment.__typename === 'Shipment3PL'">
          <span v-if="shipment.drops.weight != null" class="text-no-wrap d-block text-right wrld_black--text">{{shipment.drops.weight | roundValueWeight(0)}} kg</span>
          <span v-if="shipment.drops.volume != null" class="text-no-wrap d-block text-right wrld_black--text">{{shipment.drops.volume | roundValue(1)}} m&sup3;</span>
        </v-col>
        <v-col v-else-if="shipment.__typename === 'ShipmentCustom'">
          <span v-if="shipment.drops.weight != null" class="text-no-wrap d-block text-right wrld_black--text">{{shipment.drops.weight | roundValueWeight(0)}} kg</span>
          <span v-if="shipment.drops.volume != null" class="text-no-wrap d-block text-right wrld_black--text">{{shipment.drops.volume | roundValue(1)}} m&sup3;</span>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'WeightVolumeGroupByDay',
   components: {},
  props: {
    shipment: Object
  },
  data () {
    return {}
  },
  created () {},
  mounted () {},
  computed: {
    utilizationWeightColor () {
      if (this.$options.filters.utilizationWeight(this.shipment.drops.weight, this.shipment.vehicle.maxWeight, 0) >= 0
          && this.$options.filters.utilizationWeight(this.shipment.drops.weight, this.shipment.vehicle.maxWeight, 0) <= 50) {
        return 'var(--v-wrld_green-base);'
      } else if (this.$options.filters.utilizationWeight(this.shipment.drops.weight, this.shipment.vehicle.maxWeight, 0) >= 51
          && this.$options.filters.utilizationWeight(this.shipment.drops.weight, this.shipment.vehicle.maxWeight, 0) <= 79) {
        return 'var(--v-wrld_yellow_orange-base);'
      } else if (this.$options.filters.utilizationWeight(this.shipment.drops.weight, this.shipment.vehicle.maxWeight, 0) >= 80) {
        return 'var(--v-alert_red-base);'
      }
    },
    utilizationVolumeColor () {
      if (this.$options.filters.utilizationVolume(this.shipment.drops.volume, this.shipment.vehicle.maxVolume, 0) >= 0
          && this.$options.filters.utilizationVolume(this.shipment.drops.volume, this.shipment.vehicle.maxVolume, 0) <= 50) {
        return 'var(--v-wrld_green-base);'
      } else if (this.$options.filters.utilizationVolume(this.shipment.drops.volume, this.shipment.vehicle.maxVolume, 0) >= 51
          && this.$options.filters.utilizationVolume(this.shipment.drops.volume, this.shipment.vehicle.maxVolume, 0) <= 79) {
        return 'var(--v-wrld_yellow_orange-base);'
      } else if (this.$options.filters.utilizationVolume(this.shipment.drops.volume, this.shipment.vehicle.maxVolume, 0) >= 80) {
        return 'var(--v-alert_red-base);'
      }
    }
  },
  methods: {}

}
</script>

<style lang="scss" scoped>
.weight-volume-container-xl {
  margin-right: -8px;
}
.weight-volume-container-lg-down {
  margin-right: -14px;
}
</style>
